<gs-generic-crud *ngIf="config" [configuration]="config" canEdit="false"></gs-generic-crud>